import React, { useState } from "react";
import ReactECharts from "echarts-for-react";
import { useTheme } from "../contexts/ThemeContext";
import { color } from "framer-motion";

const ChannelAttributionChart = ({ data }) => {

    const { theme } = useTheme();
    const isDark = theme === 'dark';
    const axisColor = isDark ? '#ccc' : '#333';
    const [selectedChannel, setSelectedChannel] = useState(null);

    // Filter out items with empty or invalid channel names
    const validData = data.filter(
        (item) => item.channels && item.channels.trim() !== ""
    );

    const filteredData = selectedChannel
        ? validData.filter((item) => item.channels === selectedChannel)
        : validData;

    const option = {
        title: {
            text: "Attribution Models by Channel",
            left: "center",
            textStyle: { color: axisColor },
        },
        tooltip: {
            trigger: "axis",
        },
        legend: {
            top: 40,
            data: ["First Click", "Last Click", "Data Attribution 1", "Data Attribution 2"],
            textStyle: { fontSize: 12, color: axisColor },
        },
        grid: {
            bottom: 100,
            // left: 60,
            // right: 30,
            // top: 100,
        },
        dataZoom: [
            { type: "inside", xAxisIndex: 0 },
            // { type: "slider", xAxisIndex: 0, height: 20, bottom: 10 },
        ],
        xAxis: {
            type: "category",
            data: filteredData.map((item) => item.channels),
            axisLabel: {
                interval: 0,
                rotate: 70,
                fontSize: 12,
                color: axisColor,
                // formatter: (value) =>
                //     value.length > 12
                //         ? value.slice(0, 12) + "\n" + value.slice(12)
                //         : value,
            },
        },
        yAxis: {
            type: "value",
            axisLabel: {
                color: axisColor,
            }
        },
        color: ["#5470C6", "#91CC75", "#EE6666", "#FAC858"],
        series: [
            {
                name: "First Click",
                type: "bar",
                data: filteredData.map(
                    (item) => Math.round(item.attribution_first_click_heuristic)
                ),
            },
            {
                name: "Last Click",
                type: "bar",
                data: filteredData.map(
                    (item) => Math.round(item.attribution_last_click_heuristic)
                ),
            },
            {
                name: "Data Attribution 1",
                type: "bar",
                data: filteredData.map(
                    (item) => Math.round(item.attribution_markov_algorithmic)
                ),
            },
            {
                name: "Data Attribution 2",
                type: "bar",
                data: filteredData.map(
                    (item) => Math.round(item.attribution_shapley_size4_conv_rate_algorithmic)
                ),
            },
        ],
    };

    const onChartClick = (params) => {
        const clickedChannel = params.name;
        setSelectedChannel((prev) =>
            prev === clickedChannel ? null : clickedChannel
        );
    };

    return (
        <div className="p-4">
            <ReactECharts
                option={option}
                style={{ height: 500 }}
                onEvents={{ click: onChartClick }}
            />
        </div>
    );
};

export default ChannelAttributionChart;
